// extracted by mini-css-extract-plugin
export var card = "_m8-5";
export var cardSelected = "_m8-4";
export var image = "_m8-3";
export var modal = "_m8-0";
export var modalContent = "_m8-1";
export var table = "_m8-2";